module.exports = __webpack_public_path__ + "static/media/arbitrum.95d0408b.svg";